import { render } from "./Page404.vue?vue&type=template&id=08f4e248&scoped=true"
import script from "./Page404.vue?vue&type=script&lang=js"
export * from "./Page404.vue?vue&type=script&lang=js"

import "./Page404.vue?vue&type=style&index=0&id=08f4e248&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f4e248"]])

export default __exports__